
import Markdown from 'utils/markdown'
import HtmlMapper from './html-mapper.vue'
import CollapsibleHeadings from './collapsible-headings.vue'

export default {
  components: {HtmlMapper, CollapsibleHeadings},
  props: {
    markdown: {type: String, required: true},
    restricted: {type: Boolean, default: false},
    collapsibleHeadings: {type: Boolean, default: false},
    headingsExpanded: {type: Boolean, default: true},
  },
  data() {
    return {
      parser: new Markdown()
    }
  },
  computed:{
    nodes() {
      const div = document.createElement('div')
      div.innerHTML = this.parser.makeHTML(this.markdown)
      return div.childNodes
    }
  }
}
